/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash 93b28457539b9505617749582ee3672d */

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type PresentationScreenContentWrapperQueryVariables = {
    slug: string;
};
export type PresentationScreenContentWrapperQueryResponse = {
    readonly presentationBySlug: {
        readonly " $fragmentRefs": FragmentRefs<"PresentationScreenContent_presentation">;
    } | null;
};
export type PresentationScreenContentWrapperQuery = {
    readonly response: PresentationScreenContentWrapperQueryResponse;
    readonly variables: PresentationScreenContentWrapperQueryVariables;
};



/*
query PresentationScreenContentWrapperQuery(
  $slug: String!
) {
  presentationBySlug(slug: $slug) {
    ...PresentationScreenContent_presentation
    id
  }
}

fragment ActorItem_actor on Actor {
  __isActor: __typename
  __typename
  ... on User {
    ...UserItem_user_4qCZIv
  }
  ... on Guild {
    ...GuildItem_guild_U3Wpz
  }
}

fragment AttendEventButton_event on Event {
  rowId
  prettyUrl
  hasExternalUrl
  hasVenue
  myAttendance {
    status
    userId
    id
  }
  endAt
  owner {
    __typename
    ... on Guild {
      myMembership {
        id
      }
    }
    ... on User {
      id
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
}

fragment EventCardAttendeesSection_event on Event {
  endAt
  attendingInPerson: eventAttendeesByRelevance(condition: {status: ATTENDING_IN_PERSON}, first: 5) {
    edges {
      node {
        user {
          id
          primaryPhoto {
            id
          }
          ...UserPrimaryPhoto_user
        }
        id
      }
    }
    totalCount
  }
  attendingVirtually: eventAttendeesByRelevance(condition: {status: ATTENDING_VIRTUAL}, first: 5) {
    edges {
      node {
        user {
          id
          primaryPhoto {
            id
          }
          ...UserPrimaryPhoto_user
        }
        id
      }
    }
    totalCount
  }
  waiting: eventAttendeesByRelevance(condition: {status: WAITING_IN_PERSON}, first: 5) {
    edges {
      node {
        user {
          id
          ...UserPrimaryPhoto_user
        }
        id
      }
    }
    totalCount
  }
}

fragment EventCardPresentationsSection_event on Event {
  eventCardPresentations: presentations(first: 3, orderBy: [CREATED_AT_ASC, ID_ASC]) {
    edges {
      node {
        rowId
        presenterFirstName
        presenterLastName
        presenter {
          firstName
          lastName
          ...UserPrimaryPhoto_user
          id
        }
        id
      }
      cursor
    }
    totalCount
  }
}

fragment EventCard_event on Event {
  id
  rowId
  name
  slug
  prettyUrl
  startAt
  endAt
  timeZone
  myAttendance {
    id
  }
  visibility
  owner {
    __typename
    ...ActorItem_actor
    ... on User {
      isMe
    }
    ... on Guild {
      myMembership {
        membershipLevel
        id
      }
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
  eventCardHasPresentations: presentations(first: 1, orderBy: [CREATED_AT_ASC, ID_ASC]) {
    totalCount
  }
  coverPhoto {
    ...GraphQLImage_image
    id
  }
  ...AttendEventButton_event
  ...EventCardPresentationsSection_event
  ...EventCardAttendeesSection_event
}

fragment GraphQLImage_image on Image {
  url
}

fragment GuildCard_guild on Guild {
  slugId
  rowId
  name
  description
  type
  myMembership {
    membershipLevel
    id
  }
  ...GuildMembershipStatus_guild
  ...GuildJoinConfirmationContent_guild
  ...GuildPrimaryPhoto_guild
  primaryPhoto {
    id
  }
  backgroundPhoto {
    ...GraphQLImage_image
    id
  }
}

fragment GuildItem_guild_U3Wpz on Guild {
  slugId
  name
  ...GuildMembershipStatus_guild_U3Wpz
  ...GuildPrimaryPhoto_guild
}

fragment GuildJoinConfirmationContent_guild on Guild {
  name
  rowId
  slugId
}

fragment GuildMembershipStatus_guild on Guild {
  myMembership {
    membershipLevel
    id
  }
  networkMembers {
    totalCount
  }
}

fragment GuildMembershipStatus_guild_U3Wpz on Guild {
  myMembership {
    membershipLevel
    id
  }
  networkMembers {
    totalCount
  }
}

fragment GuildPrimaryPhoto_guild on Guild {
  type
  primaryPhoto {
    ...GraphQLImage_image
    id
  }
}

fragment PresentationEvents_presentation on Presentation {
  events(first: 4) {
    edges {
      node {
        id
        ...EventCard_event
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  id
}

fragment PresentationGuilds_presentation on Presentation {
  guilds(first: 4) {
    edges {
      node {
        id
        ...GuildCard_guild
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  id
}

fragment PresentationMetadata_presentation on Presentation {
  title
  description
  presenterFirstName
  presenterLastName
  videoSourceUrl
  prettyUrl
  presenter {
    firstName
    lastName
    primaryPhoto {
      url
      id
    }
    id
  }
}

fragment PresentationScreenContent_presentation on Presentation {
  canEdit
  description
  presenterFirstName
  presenterLastName
  prettyUrl
  title
  videoSourceUrl
  presenter {
    slugId
    firstName
    lastName
    ...UserPrimaryPhoto_user
    ...UserItem_user
    id
  }
  ...PresentationMetadata_presentation
  ...PresentationVideoPlayer_presentation
  ...PresentationEvents_presentation
  ...PresentationGuilds_presentation
}

fragment PresentationVideoPlayer_presentation on Presentation {
  videoSourceUrl
}

fragment UserDefaultPhoto_user on User {
  rowId
  emailMd5
}

fragment UserFollowingStatus_user_4qCZIv on User {
  followerCount
  isMe
  isFollowing
}

fragment UserItem_user on User {
  slugId
  firstName
  lastName
  followerCount
  ...UserPrimaryPhoto_user
  ...UserFollowingStatus_user_4qCZIv
}

fragment UserItem_user_4qCZIv on User {
  slugId
  firstName
  lastName
  followerCount
  ...UserPrimaryPhoto_user
  ...UserFollowingStatus_user_4qCZIv
}

fragment UserPrimaryPhoto_user on User {
  ...UserDefaultPhoto_user
  primaryPhoto {
    ...GraphQLImage_image
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "presenterFirstName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "presenterLastName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "prettyUrl",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slugId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emailMd5",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v13 = [
  (v11/*: any*/),
  (v12/*: any*/)
],
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "primaryPhoto",
  "plural": false,
  "selections": (v13/*: any*/),
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "followerCount",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMe",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isFollowing",
  "storageKey": null
},
v18 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 4
  }
],
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "GuildMembership",
  "kind": "LinkedField",
  "name": "myMembership",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "membershipLevel",
      "storageKey": null
    },
    (v12/*: any*/)
  ],
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v23 = [
  (v22/*: any*/)
],
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "UsersConnection",
  "kind": "LinkedField",
  "name": "networkMembers",
  "plural": false,
  "selections": (v23/*: any*/),
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v26 = {
  "kind": "Literal",
  "name": "orderBy",
  "value": [
    "CREATED_AT_ASC",
    "ID_ASC"
  ]
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v28 = {
  "kind": "Literal",
  "name": "first",
  "value": 5
},
v29 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "EventAttendeesEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "EventAttendee",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "primaryPhoto",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  (v11/*: any*/)
                ],
                "storageKey": null
              },
              (v9/*: any*/),
              (v10/*: any*/)
            ],
            "storageKey": null
          },
          (v12/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  (v22/*: any*/)
],
v30 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PresentationScreenContentWrapperQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Presentation",
        "kind": "LinkedField",
        "name": "presentationBySlug",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PresentationScreenContent_presentation"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PresentationScreenContentWrapperQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Presentation",
        "kind": "LinkedField",
        "name": "presentationBySlug",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canEdit",
            "storageKey": null
          },
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "videoSourceUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "presenter",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v12/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v18/*: any*/),
            "concreteType": "EventsConnection",
            "kind": "LinkedField",
            "name": "events",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EventsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Event",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      (v9/*: any*/),
                      (v19/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "slug",
                        "storageKey": null
                      },
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "timeZone",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventAttendee",
                        "kind": "LinkedField",
                        "name": "myAttendance",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "status",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "userId",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "visibility",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "owner",
                        "plural": false,
                        "selections": [
                          (v20/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isActor"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v6/*: any*/),
                              (v7/*: any*/),
                              (v8/*: any*/),
                              (v15/*: any*/),
                              (v9/*: any*/),
                              (v10/*: any*/),
                              (v14/*: any*/),
                              (v16/*: any*/),
                              (v17/*: any*/),
                              (v12/*: any*/)
                            ],
                            "type": "User",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v6/*: any*/),
                              (v19/*: any*/),
                              (v21/*: any*/),
                              (v24/*: any*/),
                              (v25/*: any*/),
                              (v14/*: any*/)
                            ],
                            "type": "Guild",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v12/*: any*/)
                            ],
                            "type": "Node",
                            "abstractKey": "__isNode"
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "eventCardHasPresentations",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 1
                          },
                          (v26/*: any*/)
                        ],
                        "concreteType": "PresentationsConnection",
                        "kind": "LinkedField",
                        "name": "presentations",
                        "plural": false,
                        "selections": (v23/*: any*/),
                        "storageKey": "presentations(first:1,orderBy:[\"CREATED_AT_ASC\",\"ID_ASC\"])"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "coverPhoto",
                        "plural": false,
                        "selections": (v13/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasExternalUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasVenue",
                        "storageKey": null
                      },
                      {
                        "alias": "eventCardPresentations",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 3
                          },
                          (v26/*: any*/)
                        ],
                        "concreteType": "PresentationsConnection",
                        "kind": "LinkedField",
                        "name": "presentations",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PresentationsEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Presentation",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v9/*: any*/),
                                  (v3/*: any*/),
                                  (v4/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "presenter",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v8/*: any*/),
                                      (v9/*: any*/),
                                      (v10/*: any*/),
                                      (v14/*: any*/),
                                      (v12/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v12/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v27/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v22/*: any*/)
                        ],
                        "storageKey": "presentations(first:3,orderBy:[\"CREATED_AT_ASC\",\"ID_ASC\"])"
                      },
                      {
                        "alias": "attendingInPerson",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "condition",
                            "value": {
                              "status": "ATTENDING_IN_PERSON"
                            }
                          },
                          (v28/*: any*/)
                        ],
                        "concreteType": "EventAttendeesConnection",
                        "kind": "LinkedField",
                        "name": "eventAttendeesByRelevance",
                        "plural": false,
                        "selections": (v29/*: any*/),
                        "storageKey": "eventAttendeesByRelevance(condition:{\"status\":\"ATTENDING_IN_PERSON\"},first:5)"
                      },
                      {
                        "alias": "attendingVirtually",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "condition",
                            "value": {
                              "status": "ATTENDING_VIRTUAL"
                            }
                          },
                          (v28/*: any*/)
                        ],
                        "concreteType": "EventAttendeesConnection",
                        "kind": "LinkedField",
                        "name": "eventAttendeesByRelevance",
                        "plural": false,
                        "selections": (v29/*: any*/),
                        "storageKey": "eventAttendeesByRelevance(condition:{\"status\":\"ATTENDING_VIRTUAL\"},first:5)"
                      },
                      {
                        "alias": "waiting",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "condition",
                            "value": {
                              "status": "WAITING_IN_PERSON"
                            }
                          },
                          (v28/*: any*/)
                        ],
                        "concreteType": "EventAttendeesConnection",
                        "kind": "LinkedField",
                        "name": "eventAttendeesByRelevance",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EventAttendeesEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EventAttendee",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                      (v12/*: any*/),
                                      (v9/*: any*/),
                                      (v10/*: any*/),
                                      (v14/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v12/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v22/*: any*/)
                        ],
                        "storageKey": "eventAttendeesByRelevance(condition:{\"status\":\"WAITING_IN_PERSON\"},first:5)"
                      },
                      (v20/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v27/*: any*/)
                ],
                "storageKey": null
              },
              (v30/*: any*/)
            ],
            "storageKey": "events(first:4)"
          },
          {
            "alias": null,
            "args": (v18/*: any*/),
            "filters": null,
            "handle": "connection",
            "key": "PresentationEvents_presentation_events",
            "kind": "LinkedHandle",
            "name": "events"
          },
          (v12/*: any*/),
          {
            "alias": null,
            "args": (v18/*: any*/),
            "concreteType": "GuildsConnection",
            "kind": "LinkedField",
            "name": "guilds",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "GuildsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Guild",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      (v6/*: any*/),
                      (v9/*: any*/),
                      (v19/*: any*/),
                      (v2/*: any*/),
                      (v25/*: any*/),
                      (v21/*: any*/),
                      (v24/*: any*/),
                      (v14/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "backgroundPhoto",
                        "plural": false,
                        "selections": (v13/*: any*/),
                        "storageKey": null
                      },
                      (v20/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v27/*: any*/)
                ],
                "storageKey": null
              },
              (v30/*: any*/)
            ],
            "storageKey": "guilds(first:4)"
          },
          {
            "alias": null,
            "args": (v18/*: any*/),
            "filters": null,
            "handle": "connection",
            "key": "PresentationGuilds_presentation_guilds",
            "kind": "LinkedHandle",
            "name": "guilds"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "21c6cb3355c3474093884d07fb1e336dc9a1578ce1725eef481ba299b2e9d709",
    "metadata": {},
    "name": "PresentationScreenContentWrapperQuery",
    "operationKind": "query",
    "text": null
  }
};
})();
(node as any).hash = 'b4addce89026637d3d0c32728023d21c';
export default node;
